<template>
  <a-config-provider :locale="zhCN" :theme="themeConfig" :getPopupContainer="getPopupContainer">
    <router-view></router-view>
  </a-config-provider>
</template>

<script lang="ts">
import { defineComponent, onMounted, computed, nextTick } from "vue";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import globalMessage from "@/views/message-center/global-message/index";
import "moment/dist/locale/zh-cn";
import { useRoute, useRouter } from "vue-router";
import store from "@/store";
export default defineComponent({
  name: "App",
  components: {
  },
  setup() {
    globalMessage();
    const router = useRouter();
    const getPopupContainer = (node, e) => {
      if (node) {
        let classes =
         ( node.parentNode?.parentNode?.parentNode?.getAttribute?node.parentNode?.parentNode?.parentNode?.getAttribute("class"):'' )+
          " " +
          (node.parentNode?.parentNode?.parentNode?.getAttribute?node.parentNode?.parentNode?.parentNode?.getAttribute("class"):'') +
          " " +
          (node.parentNode?.parentNode?.getAttribute?node.parentNode?.parentNode?.getAttribute("class"):'') +
          " " +
          (node.parentNode?.getAttribute?node.parentNode?.getAttribute("class"):'') +
          " " +
          node.getAttribute("class");
        // console.log('classes',classes)
        if (classes?.indexOf("append-to-body") >= 0) {
          return document.body;
        } else if (classes?.indexOf("append-to-parentnode") >= 0) {
          return node.parentNode;
        } else if (classes?.indexOf("append-to-table") >= 0) {
          let tmp =
            //document.getElementsByClassName("component-table-list-wrapper")[0] ||
            document.getElementsByClassName("a-table")[0];
          // console.log(tmp);
          return tmp;
        } else {
          return node.parentNode;
        }
      }
      return document.body;
    };

    onMounted(() => {
      // setTimeout(function(){
      //   //@ts-ignore
      //   _53Service.init("72476101");
      // },2000);
    });
    const themeConfig = computed(() => store?.state?.theme?.themeConfig);
    if(window.top!==window.self){
      window.addEventListener("message",function(e){
       console.log("🚀 ~ app.vue:58 ~ setup ~ e:", e)
       if(e?.data?.path){
        router.push(e?.data?.path)
       }
       
      })
    }
    return {
      zhCN,
      getPopupContainer,
      themeConfig,
    };
  },
});
</script>

<style lang="less">
@import "assets/styles/global";
</style>
